import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const TextSrOnly = styled.span`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const FullDateSrOnly = ({ msg }) => (
  <TextSrOnly role="alert" aria-live="polite" aria-atomic="true" title={msg} />
);

FullDateSrOnly.propTypes = {
  msg: PropTypes.string,
};
